const SixDExpenditureContent = `

Expenditure in connection with travelling, etc.

6D. [Omitted by the IT (Thirty-second Amdt.) Rules, 1999, w.e.f. 19-11-1999.]

`;

export default SixDExpenditureContent;